module.exports = __webpack_public_path__ + "static/media/no_attachment.30786ab7.svg";